/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/**
 * Array methods
 * 
 * @version 1.0.0
 */
const ArrayMethods = ( function () {

	/**
	 * Declare private properties
	 * @private
	 */

	/**
	 * Public array methods api.
	 * 
	 * @since 1.0.0
	 */
	const Util = {

		/**
		 * Check if item is present in array.
		 * 
		 * @param  {Array} arr    The array to search.
		 * @param  {*}     needle The item to search for.
		 * @return {Boolean}
		 */
		inArray: function ( arr, needle )
		{
			for ( let i = 0, len = arr.length; i < len; i++ ) {
				if ( arr[ i ] === needle ) {
					return true;
				}
			}

			return false;
		},

		/**
		 * Convert a string to an array.
		 * 
		 * @param {String} str The string to convert.
		 * @return {Array|null}
		 */
		stringToArr: function ( str )
		{
			if ( typeof str !== 'string' || str === '' ) return null;

			// remove whitespace from both ends of string
			str = str.trim();

			const regex = /^\[\s*(.*)\s*\]$/;
			let buffer = str.match( regex );
			let resultant = [];

			if ( buffer )
			{
				buffer[ 1 ] ? buffer[ 1 ].split( ',' ) : [];

				for ( let i = 0, len = buffer[ 1 ].length; i < len; i++ ) {
					resultant[ i ] = buffer[ 1 ][ i ].trim();
				}

				return resultant;
			}

			return null;
		}

	};

	return Util;

}());

/**
 * Module exports
 */
export { ArrayMethods };